import { useEffect, useMemo, useState } from "react";
import { Button } from "../../../components/ui/Button";
import { toast } from "../../../components/ui/Toast/useToast";
import { useAdditionalComments, useBodyWork, useBooking, useCRMForm, useEntryBooking, useOptionSelection, useTyreChange, useWorkSelection } from "../../../hooks/react-query/useNewService";
import { WrenchIcon } from "../../../icons";
import { LeftArrow } from "../../../icons/arrows/leftArrow";
import { getServiceBookingShowSummaryFn, getServiceBookingUndoStepFn } from "../../../transactions/serviceBooking/newServiceBooking";
import { size } from "lodash";
import Loader from "../../../components/elements/loader";
import { buildGaragesCalendar, clearSBStepStatusState, getTimeslotWindow, toUTCISOString, undoUntil, validateResponse } from "../serviceUtils";
import { useServiceCarStore } from "../../../store/serviceCarStore";
import { QUERY_KEYS } from "../../../config/constants";
import { queryClient } from "../../../utils/queryClient"
import { useOnlinePaymentInitit, useRedeemPaymentInit } from "../../../hooks/react-query/usePayment";
import usePersonStore from "../../../store/personStore";
import useLoyaltyStore from "../../../store/loyaltyStore";
import { getLoyaltyInfoFn } from "../../../transactions/loyalty/loyalty";

const { SERVICE_HISTORY } = QUERY_KEYS;


export const ServiceBookingStepHeader = ({ state, dispatch }) => {
  
  // LOCAL VARIABLES:
  const { carInfo } = useServiceCarStore();
  const { isLoyaltyEligible, isLoyaltyEnrolled, loyaltyInfo } = usePersonStore.getState();
  // const { canRedeemPickUp } = useLoyaltyStore.getState();

  const threeStepper = useMemo(()=>{
    return {
      1 : "Τύπος εργασίας",
      2 : "Τρόπος εξυπηρέτησης",
      3 : "Προγραμματισμός Ραντεβού",
      4 : "Πληρωμή",
    }
  },[state?.stepThree])

  const threeStepperNoPayment = useMemo(()=>{
    return {
      1 : "Τύπος εργασίας",
      2 : "Τρόπος εξυπηρέτησης",
      3 : "Προγραμματισμός Ραντεβού",
    }
  },[state?.stepThree])

  const fourStepper = useMemo(() =>{
    return {
      1 : "Τύπος εργασίας",
      2 : "Τρόπος εξυπηρέτησης",
      3 :  "Προγραμματισμός Ραντεβού",
      4 : "Επιπλέον πληροφορίες",
      5 : "Πληρωμή",
    }
  }, [state?.stepThree])

  const fourStepperNoPayment = useMemo(() =>{
     return {
      1 : "Τύπος εργασίας",
      2 : "Τρόπος εξυπηρέτησης",
      3 : "Προγραμματισμός Ραντεβού",
      4 : "Επιπλέον πληροφορίες",
    }
  },[state?.stepThree])
  
  // LOCAL STATE:
  const [enabledNext, setEnabledNext] = useState(false)
  const [isUndoLoading, setIsUndoLoading] = useState(false)
  const [stepTitles, setStepTitles] = useState(fourStepper)
  const [isStepFourLoading, setIsStepFourLoading] = useState(false);
  const [isStepFiveLoading, setIsStepFiveLoading] = useState(false);
  const [steperSteps, setSteperSteps] = useState(4);
  const [isEntryLoading, setIsEntryLoading] = useState(false)
  // const [nextStepButtonText, setNextStepButtonText] = useState("Επόμενο")

  const { mutateAsync: enterBooking} = useEntryBooking();
  const { mutate: workSelect, isLoading: isWorkSelectionLoading } = useWorkSelection()
  const { mutate: optionSelect, isLoading: isOptionSelectionLoading} = useOptionSelection()
  const { mutate: bookAppointment, isLoading: isBookingLoading} = useBooking()
  const { mutateAsync: additionalComments } = useAdditionalComments();
  const { mutateAsync: tyreChange } = useTyreChange();
  const { mutateAsync: bodywork } = useBodyWork();
  const { mutate: formForCRM, isLoading: isCrmLoading} = useCRMForm()
  const { mutate: paymentInit, isLoading: isPaymentLoading } = useOnlinePaymentInitit();
  const { mutate: redeemInit, isLoading: isRedeemLoading } = useRedeemPaymentInit();
  

  // FETCH DATA:
  
  // USE EFFECTS:
  //this one checks whether we have Authorized car && only service work selected => 3 steps stepper
  useEffect(()=>{
    if(state?.isAuthorizedEV 
      // && !state?.serviceLightIndicator
      && state?.options?.standarizedService === true 
      && state?.options?.bodyWork === false 
      && state?.options?.tyresChange === false) {
        if((state?.selectedPickup && state?.pickupCost === 0) || !state?.selectedPickup){
          setStepTitles(threeStepperNoPayment)
          setSteperSteps(3)
        } else {
          setStepTitles(threeStepper)
          setSteperSteps(4)
        }
      } else {
        if((state?.selectedPickup && state?.pickupCost === 0) || !state?.selectedPickup){
          setStepTitles(fourStepperNoPayment)
          setSteperSteps(4)
        } else {
          setStepTitles(fourStepper)
          setSteperSteps(5)
        }
      }
  }, [fourStepper, fourStepperNoPayment, state?.isAuthorizedEV, state?.options, state?.pickupCost, state?.selectedPickup, state.serviceLightIndicator, threeStepper, threeStepperNoPayment])

    const isLastStep = state?.step === steperSteps;
    const isPickup = ["PickupCRMForm", "PickupAvis"].includes(state?.stepThree);

    const nextStepButtonText = useMemo(() => {
      if (!isLastStep) return "Επόμενο";

      // if (isPickup) return "Πληρωμή & Προγραμματισμός";

      return "Προγραμματισμός";
    }, [isLastStep, isPickup]);

  // this one checks about the enabled state of next button
  useEffect(()=> {
    if(state?.step === 1) {
      if((state?.options?.standarizedService || state?.options?.bodyWork || state?.options?.tyresChange) && 
      ((!state?.serviceLightIndicator && state?.currentMilleage > 0) || (state?.serviceLightIndicator && state?.currentMilleage > 1))) {
        setEnabledNext(true)
      } else {
        setEnabledNext(false)
      }
    }
    if(state?.step === 2) {
      const options = [...state?.stepThreeOptions?.CRMOptions, ...state?.stepThreeOptions?.pickupOptions, ...state?.stepThreeOptions?.availabilityOptions]
      if(options?.length === 1 && options?.[0] === "PickupCRMForm"){
        dispatch({type: "SET_SELECTED_PICKUP", selectedPickup:true})
        dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: 'cash' });
        dispatch({type: "SET_LOCK_STEPPER_NEXT", lockStepperNext:false})
        dispatch({type: "SET_STEP_THREE", stepThree: options?.[0]});
      } else if (options?.length === 1 && ["FirstAvailableAvis","CRMForm"].includes(options?.[0]) && state?.stepTwoAvailableAppointments?.firstAvailable ) {
          dispatch({type: "SET_SELECTED_PICKUP", selectedPickup:false})
          dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: null });
          dispatch({type: "SET_LOCK_STEPPER_NEXT", lockStepperNext:false})
          dispatch({type: "SET_STEP_THREE", stepThree: options?.[0]});
      } else if (options?.length > 1 && ["PickupCRMForm","CRMForm"].includes(options?.[0])) {
          dispatch({type: "SET_LOCK_STEPPER_NEXT", lockStepperNext:false})
          setEnabledNext(true)
      }
      if(state?.selectedPickup === null || state?.lockStepperNext) {
        setEnabledNext(false)
      } else {
        setEnabledNext(true)
      }
    }
    if(state?.step === 3 && state?.stepThree === "CRMForm"){
      if(state?.selectedGarage && state?.calendarValues?.selectedSlots?.length > 0 && state?.calendarValues?.selectedSlots?.[0]?.date !== 'Invalid Date'){
        setEnabledNext(true)
      } else {
        setEnabledNext(false)
      }
    }
    if(state?.step === 3 && ["PickupCRMForm","PickupAvis"].includes(state?.stepThree)){
      if(state?.calendarValues?.selectedSlots?.length > 0 &&
        state?.calendarValues?.selectedSlots?.[0]?.date !== 'Invalid Date' &&
        state?.selectedGarage &&
        state?.pickupCRMFormAddress?.street && 
        state?.pickupCRMFormAddress?.number && 
        state?.pickupCRMFormAddress?.area && 
        state?.pickupCRMFormAddress?.zipCode
      ){
        setEnabledNext(true)
      } else {
        setEnabledNext(false)
      }
    }
    if(state?.step === 3 && ["FirstAvailableAvis","FirstAvailableAvisCalendar"].includes(state?.stepThree)){
      if(state?.calendarValues?.selectedSlots?.length > 0 && 
        state?.calendarValues?.selectedSlots?.[0]?.date !== 'Invalid Date' &&
        state?.selectedGarage){
        setEnabledNext(true)
      } else {
        setEnabledNext(false)
      }
    }
    if(state?.step === 4) {
      setEnabledNext(true)
    }
    if(state?.step === 5){
      setEnabledNext(
        !state?.options?.bodyWork ||
        [
          state?.bodyWork?.bodyWorkPhotos_1,
          state?.bodyWork?.bodyWorkPhotos_2,
          state?.bodyWork?.bodyWorkPhotos_3,
          state?.bodyWork?.bodyWork,
          state?.bodyWork?.accidentReport,
        ].every(Boolean)
      );
    }
  }, [state?.step, 
    state?.stepThreeOptions, 
    state?.selectedPickup, 
    state?.lockStepperNext, 
    state?.stepTwoAvailableAppointments,
    state?.stepThree, 
    state?.options?.standarizedService, 
    state?.options?.bodyWork, 
    state?.options?.tyresChange, 
    state?.currentMilleage, 
    state?.serviceLightIndicator,
    state?.selectedGarage, 
    state?.calendarValues?.selectedSlots?.length, 
    state?.pickupCRMFormAddress?.street, 
    state?.pickupCRMFormAddress?.number, 
    state?.pickupCRMFormAddress?.area, 
    state?.pickupCRMFormAddress?.zipCode, 
    state?.bodyWork?.bodyWorkPhotos_1, 
    state?.bodyWork?.bodyWorkPhotos_2, 
    state?.bodyWork?.bodyWorkPhotos_3, 
    state?.bodyWork?.bodyWork,
    state?.bodyWork?.accidentReport, 
    dispatch, 
    state?.calendarValues?.selectedSlots])

  // HANDLERS & FUNCTIONS

  const stepOneHandler = async () => {
    const optionsSelected = []
    state?.options?.standarizedService && optionsSelected?.push("standarizedService")
    state?.options?.tyresChange && optionsSelected?.push("tyreChange")
    state?.options?.bodyWork && optionsSelected?.push("bodyWork")

    const entryPayload = {
      mileage: state.currentMilleage,
      plateno: carInfo?.plateno,
      serviceLightIndicator: state?.serviceLightIndicator,
    };

    const payload = {
      workSelection: optionsSelected
    }

    try {
      setIsEntryLoading(true);
      const response = await enterBooking({ payload: entryPayload });

      if (response?.exceptions && size(response.exceptions) > 0) {
        const message = response?.exceptions?.[0] || response?.exceptions?.mileage?.[0]
        toast({
          variant: 'destructive',
          description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      } else {
        dispatch({
          type: 'SET_SERVICEFLOWID',
          serviceFlowId: response?.id,
        });

        dispatch({
          type: 'SET_AUTHORIZEDEV',
          isAuthorizedEV: response?.['Authorized/EV'],
        });

        workSelect(
          {payload: payload, serviceFlowId:response?.id}, 
          {
            onSuccess : (response) => {
              if (validateResponse(response)) {
                dispatch({ type: "SET_STEP", step: state.step + 1 })
                dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });

              };
            }
          })
        }
    } catch (e) {
      setIsEntryLoading(false);
      toast({
        variant: 'destructive',
        description: 'Παρουσιάστηκε κάποιο πρόβλημα',
      });
    } finally {
      setIsEntryLoading(false);
    }
  }

  const stepTwoHandler = async () => {
    // we need to build the logic about whether we show apointments list, 
    // crm form or calendar screen in step three
    // The logic is based on whether the user has selected pick up or not
    // and whether the available options are CRM form or first/nearest
    
    if(state?.selectedPickup && state?.stepThreeOptions?.pickupOptions?.length > 0){
      const payload = { optionSelection: state?.stepThreeOptions?.pickupOptions?.[0] }
      optionServiceHandler({
        payload,
        successOps: (response) => {
          //check this if when we have garages
          if (state?.stepThreeOptions?.pickupOptions?.[0] === "PickupCRMForm") {
            const preferedTimeslots = response?.inputs?.preferredTimeslots?.options?.map((slot)=> { return {startTime: slot?.StartTime, endTime:slot?.EndTime} })
            const preselectedDate = new Date(preferedTimeslots?.[0]?.startTime)
            dispatch({ type: "SET_CALENDAR_DATA", calendarData: preferedTimeslots});
            dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: response?.inputs?.preferredGarage?.options?.[0]})
            dispatch({ type: "SET_GARAGE_CALENDAR_DATA", garageCalendarData: response?.inputs?.preferredGarage?.options})
            dispatch({ type: 'SET_SELECTED_DATE', value: preselectedDate.toDateString()})
          }
          dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
          dispatch({ type: "SET_STEP_THREE", stepThree: state?.stepThreeOptions?.pickupOptions?.[0]});
          dispatch({ type: "SET_STEP", step: state.step + 1 });
        }
      })
    } else if(!state?.selectedPickup && state?.stepThreeOptions?.availabilityOptions?.includes("FirstAvailableAvis")) {
      const payload = { optionSelection: "FirstAvailableAvis" }
      optionServiceHandler({
        payload,
        successOps: (response) => {
          const bookingSelectOptions =
            response?.inputs?.bookingSelect?.options || [];

          const bookingCalendarOptions =
            response?.inputs?.bookingCalendar?.options || [];

          const normalized = buildGaragesCalendar(
            bookingSelectOptions,
            bookingCalendarOptions
          );
          const preselectedDate = new Date(normalized?.[0]?.calendarData?.[0]?.startTime)
          dispatch({ type: 'CLEAR_TIMESLOTS' })
          dispatch({ type: "SET_GARAGE_CALENDAR_DATA", garageCalendarData: normalized})
          dispatch({ type: "SET_CALENDAR_DATA", calendarData: bookingCalendarOptions});
          dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: normalized?.[0]})
          dispatch({ type: 'SET_SELECTED_DATE', value: preselectedDate.toDateString()})
          dispatch({ 
            type: "ADD_TIMESLOT", 
            value: getTimeslotWindow({
              slot: normalized?.[0]?.calendarData?.[0], 
              dateKey: preselectedDate.toLocaleDateString('en-CA')
            })
          })
          dispatch({ type: "SET_STEP_THREE", stepThree: "FirstAvailableAvis"});
          dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
          dispatch({ type: "SET_STEP", step: state.step + 1 });
        }
      })
    } else if(!state?.selectedPickup && state?.stepThreeOptions?.CRMOptions?.includes("CRMForm")) {
      const payload = { optionSelection: "CRMForm" }
      optionServiceHandler({
        payload,
        successOps: (response) => {
          const preferedTimeslots = response?.inputs?.preferredTimeslots?.options?.map((slot)=> { return {startTime: slot?.StartTime, endTime:slot?.EndTime} })
          dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
          dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: response?.inputs?.preferredGarage?.options?.[0]})
          dispatch({ type: "SET_GARAGE_CALENDAR_DATA", garageCalendarData: response?.inputs?.preferredGarage?.options})
          dispatch({ type: "SET_CALENDAR_DATA", calendarData: preferedTimeslots});
          dispatch({ type: 'SET_SELECTED_DATE', value: response?.inputs?.preferredTimeslots?.options?.[0]?.startTime?.toDateString()})
          dispatch({ type: "SET_STEP_THREE", stepThree: "CRMForm"});
          dispatch({ type: "SET_STEP", step: state.step + 1 });
        }
      })
    }
  }

  const stepThreeHandler = async () => {
    if(["FirstAvailableAvis","FirstAvailableAvisCalendar", "NearestAvis", "PickupAvis"].includes(state?.stepThree)){
      const payload = {
        bookingSelect: state?.selectedGarage?.garageName,
        bookingCalendar: toUTCISOString( state?.calendarValues?.selectedSlots?.[0]?.date, state?.calendarValues?.selectedSlots?.[0]?.start)
      }
      bookAppointment(
      {payload: payload, serviceFlowId:state?.serviceFlowId},
      {onSuccess: (response) => {
        if (validateResponse(response)) {
          dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
          if(isLastStep) {
            stepPaymentHandler()
          } else {
            dispatch({ type: "SET_STEP", step: state.step + 1 });
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreWidth",value: response?.inputs?.frontTyreWidth?.value ?? response?.inputs?.frontTyreWidth?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreHeight",value: response?.inputs?.frontTyreHeight?.value ?? response?.inputs?.frontTyreHeight?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreDiameter",value: response?.inputs?.frontTyreDiameter?.value ?? response?.inputs?.frontTyreDiameter?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreWidth",value: response?.inputs?.rearTyreWidth?.value ?? response?.inputs?.rearTyreWidth?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreHeight",value: response?.inputs?.rearTyreHeight?.value ?? response?.inputs?.rearTyreHeight?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreDiameter",value: response?.inputs?.rearTyreDiameter?.value ?? response?.inputs?.rearTyreDiameter?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "tyreRunFlat",value: response?.inputs?.tyreRunFlat?.value});
          }
        }
      }})
    }
    if(["PickupCRMForm"].includes(state?.stepThree)){
      const payload = {
        preferredGarage: state?.selectedGarage?.garageId,
        preferredTimeslots: state?.calendarValues?.selectedSlots?.map(slot => toUTCISOString( slot?.date, slot?.start))
      }
      formForCRM(
      {payload: payload, serviceFlowId:state?.serviceFlowId},
      {onSuccess: (response) => {
        if (validateResponse(response)) {
          dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
          if(isLastStep) {
            stepPaymentHandler()
          } else {
            dispatch({ type: "SET_STEP", step: state.step + 1 });
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreWidth",value: response?.inputs?.frontTyreWidth?.value ?? response?.inputs?.frontTyreWidth?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreHeight",value: response?.inputs?.frontTyreHeight?.value ?? response?.inputs?.frontTyreHeight?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreDiameter",value: response?.inputs?.frontTyreDiameter?.value ?? response?.inputs?.frontTyreDiameter?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreWidth",value: response?.inputs?.rearTyreWidth?.value ?? response?.inputs?.rearTyreWidth?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreHeight",value: response?.inputs?.rearTyreHeight?.value ?? response?.inputs?.rearTyreHeight?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreDiameter",value: response?.inputs?.rearTyreDiameter?.value ?? response?.inputs?.rearTyreDiameter?.placeholder,});
            dispatch({ type: "SET_TYRESCHANGE",option: "tyreRunFlat",value: response?.inputs?.tyreRunFlat?.value});
          }
        }
      }})
    }
    if(["CRMForm"].includes(state?.stepThree)){
      const preferredTimeslots = state?.calendarValues?.selectedSlots?.map(slot => toUTCISOString( slot?.date, slot?.start))
      const payload = {
        preferredGarage: state?.selectedGarage?.garageId,
        preferredTimeslots: preferredTimeslots
      }
      try{
        formForCRM({payload, serviceFlowId:state?.serviceFlowId },
        {
          onSuccess : (response) => {
            if (validateResponse(response)) { 
              dispatch({ type: "SET_STEPSTATUS", stepStatus: response?.name });
              if(isLastStep) {
                stepPaymentHandler()
              } else {
                dispatch({ type: "SET_STEP", step: state.step + 1 });
                dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreWidth",value: response?.inputs?.frontTyreWidth?.value ?? response?.inputs?.frontTyreWidth?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreHeight",value: response?.inputs?.frontTyreHeight?.value ?? response?.inputs?.frontTyreHeight?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "frontTyreDiameter",value: response?.inputs?.frontTyreDiameter?.value ?? response?.inputs?.frontTyreDiameter?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreWidth",value: response?.inputs?.rearTyreWidth?.value ?? response?.inputs?.rearTyreWidth?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreHeight",value: response?.inputs?.rearTyreHeight?.value ?? response?.inputs?.rearTyreHeight?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "rearTyreDiameter",value: response?.inputs?.rearTyreDiameter?.value ?? response?.inputs?.rearTyreDiameter?.placeholder,});
                dispatch({ type: "SET_TYRESCHANGE",option: "tyreRunFlat",value: response?.inputs?.tyreRunFlat?.value});
              }
            }
          }
        }
      )} catch(e) {
        console.warn(e)
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      }
    }
  }

  const stepFourHandler = async () => {
    // dispatch({ type: "SET_STEP", step: state?.step + 1 });
    setIsStepFourLoading(true);
    let currentStepStatus = state?.stepStatus;

    const tyresPayload = {
      frontTyreWidth: state?.tyresChange?.frontTyreWidth,
      frontTyreHeight: state?.tyresChange?.frontTyreHeight,
      frontTyreDiameter: state?.tyresChange?.frontTyreDiameter,
      rearSameAsFront: state?.tyresChange?.rearSameAsFront,
      rearTyreWidth: state?.tyresChange?.rearTyreWidth,
      rearTyreHeight: state?.tyresChange?.rearTyreHeight,
      rearTyreDiameter: state?.tyresChange?.rearTyreDiameter,
    };

    const bodyworkPayload = {
      bodyWork: state?.bodyWork?.bodyWork,
      bodyWorkPhotos_1: state?.bodyWork?.bodyWorkPhotos_1,
      bodyWorkPhotos_2: state?.bodyWork?.bodyWorkPhotos_2,
      bodyWorkPhotos_3: state?.bodyWork?.bodyWorkPhotos_3,
      accidentReport: state?.bodyWork?.accidentReport,
    };

    try {
      if (state?.options?.tyresChange) {
        const tyreRes = await tyreChange({
          payload: tyresPayload,
          serviceFlowId: state?.serviceFlowId,
        });

        if (!validateResponse(tyreRes)) {
          // await undoUntil({targetStep : "tyreChange", state, dispatch})
          return;
        } else {
          currentStepStatus = tyreRes?.name;
          dispatch({
            type: 'SET_STEPSTATUS',
            stepStatus: tyreRes?.name,
          });
         if (!state?.options?.bodyWork) {
            if(isLastStep) {
              stepPaymentHandler()
            } else {
              dispatch({ type: "SET_STEP", step: state?.step + 1 });
            }
            return
         }
        }
      }

      if (state?.options?.bodyWork) {
        const bodyRes = await bodywork({
          payload: bodyworkPayload,
          serviceFlowId: state?.serviceFlowId,
        });

        if (!validateResponse(bodyRes)) {
          if(state?.options?.tyresChange) {
            await undoUntil({targetStep : "tyreChange", state: { ...state, stepStatus: currentStepStatus }, dispatch})
          }
          return;
        } else {
          currentStepStatus = bodyRes?.name;
          dispatch({
            type: 'SET_STEPSTATUS',
            stepStatus: bodyRes?.name,
          });
          if(isLastStep) {
            stepPaymentHandler()
          } else {
            dispatch({ type: "SET_STEP", step: state?.step + 1 });
          }
          return
        }

      }
      
      if (state?.options?.standarizedService && !state?.options?.tyresChange && !state?.options?.bodyWork) {
        if(isLastStep) {
          stepPaymentHandler()
        } else {
          dispatch({ type: "SET_STEP", step: state?.step + 1 });
        }
      }
    } catch (error) {
      console.warn(error);
      if(state?.options?.tyresChange) {
        await undoUntil({targetStep : "tyreChange", state, dispatch})
      }
      if(!state?.options?.tyresChange && state?.options?.bodyWork) {
        await undoUntil({targetStep : "bodyWork", state, dispatch})
      }
      toast({
        variant: 'destructive',
        description: 'Παρουσιάστηκε κάποιο πρόβλημα',
      });
    } finally {
      setIsStepFourLoading(false);
    }
  }

  const stepPaymentHandler = async () => {
    const servicePayload = {
      additionalComments: state?.standarizedService?.additionalComments,
    };
    setIsStepFiveLoading(true)
    
    try{
      if(state?.stepStatus !== "payment") {
          const serviceRes = await additionalComments({
          payload: servicePayload,
          serviceFlowId: state?.serviceFlowId,
        });
        if (validateResponse(serviceRes)) {
            if(serviceRes?.pendingPayment) {
              dispatch({
              type: 'SET_STEPSTATUS',
              stepStatus: "payment",
            });
            const summaryRes = await getServiceBookingShowSummaryFn(state?.serviceFlowId)

            if (!validateResponse(summaryRes)) {
              const message = summaryRes?.exceptions?.[0] || 'Παρουσιάστηκε κάποιο πρόβλημα';
              toast({
                variant: 'destructive',
                description: message,
              });
              return;
            } else {
              if(summaryRes?.pendingPayment) {
                initiatePayment()
              } else {
                dispatch({ type: "SET_STEP", step: 6 });
                dispatch({ type: "SET_SUMMARY", appointmentSummary: summaryRes });
                queryClient.invalidateQueries({ 
                  queryKey: [SERVICE_HISTORY, summaryRes?.plateno]
                });
              }
            }
          } else {
            dispatch({ type: "SET_STEP", step: 6 });
            dispatch({ type: "SET_SUMMARY", appointmentSummary: serviceRes });
            queryClient.invalidateQueries({ 
              queryKey: [SERVICE_HISTORY, serviceRes?.plateno]
            });
          }
        }
      } else if (state?.stepStatus === "payment") {
        initiatePayment()
      }
    } catch(e) {
      console.warn(e);
    } finally{
      setIsStepFiveLoading(false)
    }
  };

  const optionServiceHandler = ({payload, successOps}) => {
    try{
        optionSelect({payload, serviceFlowId:state?.serviceFlowId },
        {
          onSuccess : (response) => {
            if (validateResponse(response)) successOps(response)
          }
        }
      )} catch(e) {
        console.warn(e)
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      }
  }

  const initiatePayment = () => {
    try {
      if(state?.selectedPayment === 'loyaltyPoints'){
        redeemInit(
          {
            serviceFlowId: state?.serviceFlowId,
            redemptionType: '00009',
          },
          {
            onSuccess: async (response) => {
              validateResponse(response)
              if (response.exceptions) {
                if (response.exceptions.length === 0) {
                  // const data = JSON.parse(response.data);
                  // const url = data.url;
                  // url && window.location.replace(url);
                  dispatch({ type: "SET_STEP", step: 6 });
                  queryClient.invalidateQueries({ 
                    queryKey: [SERVICE_HISTORY, carInfo?.plateno]
                  });
                  const freshLoyaltyInfo = await getLoyaltyInfoFn();
                  const { setLoyaltyInfo } = usePersonStore.getState();
                  setLoyaltyInfo(freshLoyaltyInfo);
                }
              }
            },
          }
        );
      } else if(state?.selectedPayment === 'cash') {
        paymentInit(
          {
            serviceFlowId: state?.serviceFlowId,
            payment_type: 'pickupDelivery',
            // documentType: state?.hasSelectedInvoice ? "invoice" : "receipt"
          },
          {
            onSuccess: (response) => {
              validateResponse(response)
              if (response.exceptions) {
                if (response.exceptions.length === 0) {
                  const data = JSON.parse(response.data);
                  const url = data.url;
                  url && window.location.replace(url);
                }
              }
            },
          }
        );
      }
      
    } catch(e) {
      console.warn(e)
    }
  }

  const nextStep = async () => {  
    if (state.step < 6 && enabledNext) {
      state?.step === 1 && stepOneHandler()
      state?.step === 2 && stepTwoHandler()
      state?.step === 3 && stepThreeHandler()
      // step 4 is payment method
      state?.step === 4 && stepFourHandler()
      state?.step === 5 && stepPaymentHandler()
    }
  };

  const prevStep = async () => {
    setIsUndoLoading(true)
    if(state?.step === 2) {
      const isTesla = state?.isTesla
      const showLightIndicator = state?.showServiceLightIndicatorNeeded
      dispatch({ type: "RESET" });
      dispatch({ type: "SET_ISTESLA", isTesla: isTesla });
      dispatch({type: "SET_SHOW_LIGHT_INDICATOR", showServiceLightIndicatorNeeded: showLightIndicator})
      dispatch({ type: "SET_STEP", step: 1 });
      setIsUndoLoading(false)
    }
    
    if(state?.step === 3) {

      try {
        if(state?.stepThreeOptions?.pickupOptions?.length > 0) {
          const undoStatus = await undoUntil({targetStep : "optionSelection", state, dispatch})
          if(undoStatus?.success) {
            dispatch({ type: "SET_STEP", step: state.step - 1 });
            clearSBStepStatusState({targetStepStatus: "optionSelection", dispatch})
          } else {
            toast({
              variant: 'destructive',
              description: undoStatus?.message,
            });
          }
        } else if (state?.stepThreeOptions?.pickupOptions?.length === 0) {
          const undoStatus = await undoUntil({targetStep : "location", state, dispatch})
          if(undoStatus?.success) {
            dispatch({ type: "SET_STEP", step: state.step - 1 });
            clearSBStepStatusState({targetStepStatus: "location", dispatch})
          } else {
            toast({
              variant: 'destructive',
              description: undoStatus?.message,
            });
          }
        }
      } catch (e) {
        console.warn(e)
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      } finally {
        setIsUndoLoading(false)
      }
    }
    
    if(state?.step === 4) {
      clearSBStepStatusState({targetStepStatus: "booking", dispatch})
      try {
        const undoStatus = await undoUntil({targetStep : "booking", state, dispatch})
        if(undoStatus?.success) {
          dispatch({ type: "SET_STEP", step: state.step - 1 });
        } else {
          toast({
            variant: 'destructive',
            description: undoStatus?.message,
          });
        }
      } catch (e) {
        console.warn(e)
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      } finally {
        setIsUndoLoading(false)
      }
    }
    
    if(state?.step === 5) {
      dispatch({ type: "SET_STEP", step: state.step - 1 });
    }
    setIsUndoLoading(false)
  };

  return (
    <>
      {(isEntryLoading || 
        isWorkSelectionLoading || 
        isOptionSelectionLoading || 
        isUndoLoading || 
        isBookingLoading || 
        isStepFourLoading ||
        isStepFiveLoading ||
        isCrmLoading ||isPaymentLoading || isRedeemLoading
      ) && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[2px]">
          <Loader />
        </div>
      )}
      <div className="flex flex-row justify-between items-center w-[90%] pb-4 mb-10 border-b-[0.5px] border-fadedgrey lg:mr-[45px]">
        <div className='flex flex-row gap-2 items-center' >
          {state?.step > 0 &&
          <>
            {state?.step > 1 && <Button className='h-full pl-1' onClick={prevStep}><LeftArrow className='cursor-pointer'/></Button>}
            <WrenchIcon className="stroke-black w-[18px] h-[18px]"/>
            <h4 className='font-bold'>{stepTitles[state?.step] ?? ""}</h4>
          </>}
        </div>
        <Button className={`text-white text-sm font-bold ${!enabledNext? "bg-fadedgrey" : "bg-[#D4002A]"} py-3 px-10 rounded-[6px]`} disabled={!enabledNext} onClick={nextStep}>{nextStepButtonText}</Button>
      </div>
    </>
  );
};